<template>
	<div class="test__question__show-answer">
		<div class="test__question__show-answer__answer-text-canvas">
			<div
				:class="{ 'blured' : bluredAnswer }"
				class="test__question__show-answer__answer-text"
			>
				<v-runtime-template :template="findAndRenderLaTeX(question.answer)" />
			</div>
			<div class="test__question__show-answer__button-layer" v-if="bluredAnswer">
				<b-button
					@click="bluredAnswer = false, showAnswerButtons = true"
					variant="show-answer">
					<div class="d-flex align-items-center">
						<svg xmlns="http://www.w3.org/2000/svg" width="26.862" height="14.546" viewBox="0 0 26.862 14.546">
							<g transform="translate(0 -104.721)">
								<g transform="translate(0 104.721)">
								<path d="M26.4,111.41a20.06,20.06,0,0,0-3.587-3.341,15.961,15.961,0,0,0-9.383-3.349,15.962,15.962,0,0,0-9.383,3.349A20.063,20.063,0,0,0,.461,111.41L0,111.994l.461.584a20.064,20.064,0,0,0,3.587,3.341,15.962,15.962,0,0,0,9.383,3.349,15.961,15.961,0,0,0,9.383-3.349,20.06,20.06,0,0,0,3.587-3.341l.462-.584Zm-12.97,5.679a5.1,5.1,0,0,1-4.934-6.37l-1.163-.2a6.267,6.267,0,0,0,1.837,6.069,16.511,16.511,0,0,1-3.966-2.159,19.767,19.767,0,0,1-2.754-2.439,19.773,19.773,0,0,1,2.754-2.439A16.515,16.515,0,0,1,9.171,107.4l.78.88a5.094,5.094,0,1,1,3.479,8.813Zm8.226-2.656a16.515,16.515,0,0,1-3.966,2.159,6.261,6.261,0,0,0,0-9.2,16.515,16.515,0,0,1,3.966,2.159,19.771,19.771,0,0,1,2.754,2.439A19.76,19.76,0,0,1,21.657,114.433Z" transform="translate(0 -104.721)" fill="#154370"/>
								<path d="M170.9,173.155a3.4,3.4,0,1,0,.894-1.453l1.672,1.885Z" transform="translate(-160.713 -166.873)" fill="#154370"/>
								</g>
							</g>
						</svg>
						<div class="ml-2">
							Zobrazit
						</div>
					</div>
				</b-button>
			</div>
		</div>

		<b-collapse
			:id="'question-' + questionIndex + 'show-answer-buttons'"
			v-model="showAnswerButtons">
			<div class="d-flex mt-2">
				<div class="w-50 pr-1 pb-2">
					<b-button
						@click="incorrectlyEvaluatedAnswer(questionIndex), showAnswerButtons = false"
						:disabled="question.answerStatus !== null"
						variant="red" block>
						Nevěděl jsem
					</b-button>
				</div>
				<div class="w-50 pl-1 pb-2">
					<b-button
						@click="correctlyEvaluatedAnswer(questionIndex), showAnswerButtons = false"
						:disabled="question.answerStatus !== null"
						variant="green" block>
						Věděl jsem
					</b-button>
				</div>
			</div>
		</b-collapse>

	</div>
</template>

<script>
import { mapActions } from "vuex";

export default {
	name: 'ShowAnswer',
	
	props: ['questionIndex'],
	
	data() {
		return {
			bluredAnswer: true,
			showAnswerButtons: false,
		}
	},

	// Příprava dat před tím, než se začne cokoliv vykonávat
	created() {
		this.question = this.$store.state.testData.questions[this.$props.questionIndex];
	},

	methods: {
		...mapActions([
			'correctlyEvaluatedAnswer',
			'incorrectlyEvaluatedAnswer',
		])
	}
}
</script>